import styled from '@emotion/styled';

export const AdminSettingsFormsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 752px;
`;
